import Award01 from "./award-01";
import Award02 from "./award-02";
import Award03 from "./award-03";
import Award04 from "./award-04";
import Award05 from "./award-05";
import Certificate01 from "./certificate-01";
import Champion from "./champion";
import Crown from "./crown";
import Honor from "./honor";
import HonourStar from "./honour-star";
import LaurelWreath01 from "./laurel-wreath-01";
import LaurelWreath02 from "./laurel-wreath-02";
import LaurelWreathFirst01 from "./laurel-wreath-first-01";
import LaurelWreathFirst02 from "./laurel-wreath-first-02";
import LaurelWreathLeft01 from "./laurel-wreath-left-01";
import LaurelWreathLeft02 from "./laurel-wreath-left-02";
import LaurelWreathLeft03 from "./laurel-wreath-left-03";
import LaurelWreathRight01 from "./laurel-wreath-right-01";
import LaurelWreathRight02 from "./laurel-wreath-right-02";
import LaurelWreathRight03 from "./laurel-wreath-right-03";
import Medal01 from "./medal-01";
import Medal02 from "./medal-02";
import Medal03 from "./medal-03";
import Medal04 from "./medal-04";
import Medal05 from "./medal-05";
import Medal06 from "./medal-06";
import Medal07 from "./medal-07";
import MedalFirstPlace from "./medal-first-place";
import MedalSecondPlace from "./medal-second-place";
import MedalThirdPlace from "./medal-third-place";
import NewReleases from "./new-releases";
import Ranking from "./ranking";
import StarAward01 from "./star-award-01";
import StarAward02 from "./star-award-02";

export * from "./award-01";
export * from "./award-02";
export * from "./award-03";
export * from "./award-04";
export * from "./award-05";
export * from "./certificate-01";
export * from "./champion";
export * from "./crown";
export * from "./honor";
export * from "./honour-star";
export * from "./laurel-wreath-01";
export * from "./laurel-wreath-02";
export * from "./laurel-wreath-first-01";
export * from "./laurel-wreath-first-02";
export * from "./laurel-wreath-left-01";
export * from "./laurel-wreath-left-02";
export * from "./laurel-wreath-left-03";
export * from "./laurel-wreath-right-01";
export * from "./laurel-wreath-right-02";
export * from "./laurel-wreath-right-03";
export * from "./medal-01";
export * from "./medal-02";
export * from "./medal-03";
export * from "./medal-04";
export * from "./medal-05";
export * from "./medal-06";
export * from "./medal-07";
export * from "./medal-first-place";
export * from "./medal-second-place";
export * from "./medal-third-place";
export * from "./new-releases";
export * from "./ranking";
export * from "./star-award-01";
export * from "./star-award-02";

export const Awards = {
  Award01,
  Award02,
  Award03,
  Award04,
  Award05,
  Certificate01,
  Champion,
  Crown,
  Honor,
  HonourStar,
  LaurelWreath01,
  LaurelWreath02,
  LaurelWreathFirst01,
  LaurelWreathFirst02,
  LaurelWreathLeft01,
  LaurelWreathLeft02,
  LaurelWreathLeft03,
  LaurelWreathRight01,
  LaurelWreathRight02,
  LaurelWreathRight03,
  Medal01,
  Medal02,
  Medal03,
  Medal04,
  Medal05,
  Medal06,
  Medal07,
  MedalFirstPlace,
  MedalSecondPlace,
  MedalThirdPlace,
  NewReleases,
  Ranking,
  StarAward01,
  StarAward02,
};
